import classes from "./ImagesCarousel.module.css"
import ImagesCarouselAnimation from "./ImagesCarouselAnimation";

const ImagesCarousel = () => {

  return (
    <div className={classes.secondSectionContainer}>
      <div className={classes.secondSectionInfosContainer}>
        <h2>Studios für Musik, Foto und Video.</h2>
        <div className={classes.secondSectionExtraInfos}>
          <span>Neue Fashion-Kollektion? Entdecke einzigartige Kulissen.</span>
          <span>Du hast ein kleines Homestudio? Mache Geld daraus.</span>
          <span>All das und vieles mehr kann Stu.</span>
        </div>
      </div>
      <ImagesCarouselAnimation />
      <div className={classes.longLineContainer}>
        <div className={classes.longLine}></div>
      </div>
    </div>
  );
};

export default ImagesCarousel;